import React from 'react'
import { useFormContext } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";

const FloatInput = ({ field_id, field_label, field_placeholder, field_value }) => {
    const { register, errors } = useFormContext();

    // Inputmask removed (see Currency.js) — native type="number" is caret-stable
    // and numeric-safe; the backend strips $ , % so the wire format is unchanged.
    return (
        <div className="mb-3">
            <label htmlFor={field_id} className="form-label">{field_label}</label>
            <input type="number" step="any" className="form-control" id={field_id}
                inputMode="decimal"
                placeholder={field_placeholder ? field_placeholder : ''}
                key={field_id}
                {...register(field_id, {
                    required: "This is a required field"
                })}
            />
            <ErrorMessage
                errors={errors}
                name={field_id}
                render={({ message }) => <p className="fb-error-message">{message}</p>}
            />
        </div>
    )
}

export default FloatInput